import { DraggableWindowHeader, Icon } from "@hoylu/client-common";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashboardOption } from "@/enums/DashboardOption.enum";
import { selectDashboardSelectedProject } from "../state/workspaces/projects.selector";
import type { WorkspaceLabels } from "../state/workspaces/types";
import * as workspacesActions from "../state/workspaces/workspaces.actions";
import { useI18n } from "../utils/hooks/use.i18n";
import Styles from "./FilterByWorkspaceTag.module.css";
import useAutoVisibility from "./hooks/useAutoVisibility";
import { EditLabelContent } from "./modals/EditLabelContent";

export type FilterByWorkspaceTagProps = {
  allLabels: WorkspaceLabels;
  selectedLabels: WorkspaceLabels;
  handleLabelsChange: (selected: WorkspaceLabels) => void;
};

const filterIconStyle = { color: "var(--theme-text)" };

export const FilterByWorkspaceTag: React.FC<FilterByWorkspaceTagProps> = ({
  allLabels,
  handleLabelsChange,
  selectedLabels,
}) => {
  const dispatch = useDispatch();

  const t = useI18n("FILTER_BY_WORKSPACE_LABEL.");

  const { ref, componentVisible, setComponentVisible } =
    useAutoVisibility(false);

  const isProjectView = useSelector(selectDashboardSelectedProject);

  const openFilters = () => {
    if (componentVisible) {
      dispatch(workspacesActions.cancelDashboardOption());
    } else {
      dispatch(
        workspacesActions.activateDashboardOption({
          optionType: DashboardOption.FILTER,
        }),
      );
    }
    setComponentVisible((componentVisible) => !componentVisible);
  };

  const title = t("FILTER_BY_LABELS");
  const tClose = useI18n("CLOSE_BUTTON.");

  return (
    <div
      aria-label={title}
      className={Styles.filterByWorkspaceTag}
      ref={ref}
      tabIndex={0}
    >
      <Icon
        hoverStyle={filterIconStyle}
        icon="hoylu-ui-icons-filter"
        onClick={openFilters}
        style={filterIconStyle}
        testId="filter-by-label"
        title={title}
      />
      {componentVisible && (
        <div className={Styles.filterByWorkspaceTagDialog}>
          <DraggableWindowHeader
            close={tClose("CLOSE")}
            onClose={() => setComponentVisible(false)}
            title={title}
          />
          <EditLabelContent
            allLabels={allLabels}
            canAddNewLabels={false}
            enableHiddenWorkspaceSearch={!isProjectView}
            selected={selectedLabels}
            subscribeLabelsChanges
            updateSelected={handleLabelsChange}
          />
        </div>
      )}
    </div>
  );
};
